import { Component, AfterViewInit, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { jwtDecode } from 'jwt-decode';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'ngx-toastr';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { FacebookLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';

declare const google: any;
interface GoogleSignInResponse {
  credential: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user: any;
  loggedIn: any;
  token:any;
  c_p_hide: boolean = true;
  p_hide: boolean = true;
  ErrorLoggingIn: boolean = false;
  LoginErrorMessage: string = "";
  UserId: string = "";
  Photo: string = "";
  FirstName: string = "";
  LastName: string = "";
  AccountType: string = "WebSite";
  MobileNumber: string = "000000000";
  RemeberMe: boolean = false;
  getSafeValue(value: string | null): string {
    return (value === null || value === "undefined") ? "" : value;
  }
  Email = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  Password = new FormControl('', [
    Validators.required, Validators.pattern(/^.{5}/)
  ]);

  getEmailError() {
    if (this.Email.hasError('required')) {
      return 'Email is required.';
    }
    else if (this.Email.hasError('email')) {
      return 'Please enter a valid email address.';
    }
    else {
      return '';
    }

  }

  getPasswordError() {
    if (this.Password.hasError('required')) {
      return 'Password is required.';
    }
    else if (this.Password.hasError('pattern')) {
      return 'Please enter a password more than 5 letters';
    }
    else {
      return '';
    }

  }

  constructor(
    private authService: SocialAuthService,
    public service: SharkifyAiSerivceService,
    public router: Router,
    public app: AppComponent, private toastr: ToastrService
  ) { }

  ngOnInit(): void {

    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
      if(this.loggedIn){
        this.AccountType = "Facebook"
        let email = this.user.email;
        this.FirstName = this.user.FirstName;
        this.LastName = this.user.LastName;
        this.callapi(email);
      }
    });
   
    this.initializeGoogleSignIn();
    this.loadRememberedCredentials();
  }
 

  public initializeGoogleSignIn(): void {
    google.accounts.id.initialize({
      client_id: '156115123288-vl54pajt16k4cs0ld2b9dbh9oep12q6s.apps.googleusercontent.com',
      callback: (response: GoogleSignInResponse) => this.handleCredentialResponse(response),
      cancel_on_tap_outside: false
    });

    google.accounts.id.prompt((notification: any) => {
      // if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
      //   this.showError('Google sign-in was canceled or not displayed.');
      // }
    });

    google.accounts.id.renderButton(
      document.getElementById('google-signin-btn'),
      {
        type: 'icon',
        theme: 'outline',
        size: 'large',
        shape: 'circle'
      }
    );

    google.accounts.id.prompt();{
      
    }
  }

  private handleCredentialResponse(response: GoogleSignInResponse): void {
    try {
      const idToken = response.credential;
      const decodedToken: any = jwtDecode(idToken);
      const email = decodedToken.email;
      const name = decodedToken.name;
      const nameParts = name.split(' ');
      this.FirstName = nameParts[0].trim();
      this.LastName = nameParts.length > 1 ? nameParts.slice(1).join(' ').trim() : '';
      const picture = decodedToken.picture;
      this.Photo = picture;
      this.AccountType = "Gmail";
      this.callapi(email);
    } catch (error) {
      console.error('Error decoding token:', error);
      this.app.displayLoader(false);
    }
  }

  callapi(data: any){
    this.service.ClientSocialMediaAccountLogin(data, this.MobileNumber + "", this.FirstName + "", this.LastName + "", this.AccountType + "", "", this.Photo + "").subscribe(data => {
      if (data.Code === 200) {
        this.setdata(data);
        // this.rememberCredentials();
        this.showSuccess('Login Successful');

        if (this.BusinessInfo == 0) {
          this.router.navigate(["/Dashboard/Questionary"]);
        } else {
          this.router.navigate(["/Dashboard/Home"]);
        }
      } else {
        this.showError('Login Failed. Please check your credentials.');
      }
    }, error => {
      this.showError('Server error occurred. Please try again later.');
    });
  }

 

  
  private rememberCredentials(): void {
    if (this.RemeberMe) {
      localStorage.setItem('rememberedEmail', this.Email.value ?? '');
      localStorage.setItem('rememberedPassword', this.Password.value ?? '');
    } else {
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem('rememberedPassword');
    }
  }
  loadRememberedCredentials() {
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    const rememberedPassword = localStorage.getItem('rememberedPassword');
    if (rememberedEmail && rememberedPassword) {
      this.RemeberMe = true;
      if (this.BusinessInfo == 0) {
        this.router.navigate(["/Dashboard/Questionary"]);
      } else {
        this.router.navigate(["/Dashboard/Home"]);
      }
    }
  }


  private showSuccess(message: string): void {
    this.toastr.success(message, 'Success', {
      toastClass: 'ngx-toastr toast-success'
    });
  }
  private showError(message: string): void {
    this.toastr.error(message, 'Error', {
      toastClass: 'ngx-toastr toast-error'
    });
  }
  setdata(data: any) {
    console.log(data);
    const userDetails = data.UserDetails;
    localStorage.setItem("UserId", "" + userDetails.UserId);
    localStorage.setItem("BusinessInfo", "" + userDetails.BusinessInfo);
    localStorage.setItem("FirstName", "" + userDetails.FirstName);
    localStorage.setItem("LastName", "" + userDetails.LastName);
    localStorage.setItem("Email", "" + userDetails.Email);
    localStorage.setItem("MobileNumber", "" + userDetails.MobileNumber);
    localStorage.setItem("Photo", "" + userDetails.Photo);
    localStorage.setItem("IsEmailVerified", "" + userDetails.IsEmailVerified);
    localStorage.setItem("IsMobileNumberVerified", "" + userDetails.IsMobileNumberVerified);
    localStorage.setItem("Status", "" + userDetails.Status);
    localStorage.setItem("AddressLineOne", "" + userDetails.AddressLineOne);
    localStorage.setItem("AddressLineTwo", "" + userDetails.AddressLineTwo);
    localStorage.setItem("City", "" + userDetails.City);
    localStorage.setItem("State", "" + userDetails.State);
    localStorage.setItem("Pincode", "" + userDetails.Pincode);
    localStorage.setItem("Password", "" + userDetails.Password);
    localStorage.setItem("AccountType", "" + userDetails.AccountType);
    localStorage.setItem("AccountId", "" + userDetails.AccountId);
    localStorage.setItem("authToken", "Accept" );
    this.BusinessInfo = localStorage.getItem("BusinessInfo");
  }
  
  signUp() {
    this.router.navigate(["/SignUp"]);
  }

 

  BusinessInfo: any;
  signIn(): void {
    this.app.displayLoader(true);
    if (this.Email.valid && this.Password.valid) {
      this.service.ClientLogin(this.Email.value + "", this.Password.value + "").subscribe(data => {
        if (data.Code === 200) {
          console.log(data);
          const UserDetails = data.UserDetails;
          console.log(localStorage.getItem("PushNotificationToken"));
          this.token=localStorage.getItem("PushNotificationToken")
          // console.log("push",tPushNotificationToken)
          console.log("hi testing",this.token)
           const details = {FirebaseToken: this.token}
          // call updateUser api
          this.service.updateUser(UserDetails.UserId, details).subscribe(data => {
            console.log('User updated successfully', data);
          },
          error => {
            console.error('Error updating user', error);
          }
          )
          this.setdata(data);
          this.rememberCredentials();
          this.showSuccess('Login Successful');

          if (this.BusinessInfo == 0) {
            this.router.navigate(["/Dashboard/Questionary"]);
          } else {
            this.router.navigate(["/Dashboard/Home"]);
          }
          this.app.displayLoader(false);
        } else {
          // Show error message
          this.showError('Login Failed. Please check your credentials.');
          this.app.displayLoader(false);
        }
      }, 
      error => {

        this.showError('Server error occurred. Please try again later.');
        this.app.displayLoader(false);
      });
    } else {

      this.showError('Please fill in valid credentials.');
      this.app.displayLoader(false);
    }
  }
}
